export const limit = {
    mounted(el, binding) {
        const limit = parseInt(binding.value);
        const text = el.textContent;
        if (text.length > limit) {
            el.textContent = text.slice(0, limit) + "...";
        }
    },
};
